/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSignOutAlt} from '@fortawesome/pro-duotone-svg-icons';

const LogOutIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faSignOutAlt} {...props} />
);

export default LogOutIcon;
